import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=d245040a&"
import script from "./AccountAdd.vue?vue&type=script&lang=js&"
export * from "./AccountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d245040a')) {
      api.createRecord('d245040a', component.options)
    } else {
      api.reload('d245040a', component.options)
    }
    module.hot.accept("./AccountAdd.vue?vue&type=template&id=d245040a&", function () {
      api.rerender('d245040a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Reseller/AccountAdd.vue"
export default component.exports